<template>
    <div>
        <v-row>
            <v-col md="2" cols="12">
                <div class="elevation-2 pa-4 size-card d-flex align-center justify-center flex-column">
                     <img :src="channelAssets.logo" alt="">
                    <span class="mt-2 grey--text text--darken-3 body-2">{{channelAssets.name}}</span>
                </div>
            </v-col>
            <v-col md="5" cols="12">
                <div class="elevation-2 pa-4 size-card">
                    <span class="grey--text text--darken-4 body-1">
                        Resumo do Dossiê
                    </span>
                    <p class="grey--text text--darken-3 caption mt-4">
                       {{summary}}
                    </p>
                </div>
            </v-col>
            <v-col md="3" cols="12">
                <div class="elevation-2 pa-4 size-card">
                    <span class="grey--text text--darken-4 body-1">
                        Informações do Canal
                    </span>
                    <div class="grey--text text--darken-3 mt-1 caption mt-4" v-if="permissions.indexOf('view_monetary_data') != -1">
                        Preço de aquisição do canal: {{formatterMoney.format(info.channel_price)}}
                    </div>
                    <div class="grey--text text--darken-3 mt-1 caption">
                        Data de aquisição do canal: {{moment(info.channel_bought_at).format('DD/MM/YYYY')}}
                    </div>
                    <div class="grey--text text--darken-3 mt-1 caption">
                        Tempo decorrido desde a aquisição do canal:
                        {{info.days_after_purchase}}
                        <span v-if="info.days_after_purchase == 1"> dia</span>
                        <span v-else> dias</span>

                    </div>
                    <div class="grey--text text--darken-3 mt-1 caption" v-if="permissions.indexOf('view_monetary_data') != -1">
                        Receita do BP: {{formatterMoney.format(info.bp_revenue)}}/mês
                    </div>
                    <div class="grey--text text--darken-3 mt-1 caption">
                        Tempo de Payback previsto no BP:
                        {{info.bp_payback_months}}
                        <span v-if="info.bp_payback_months == 1"> mês</span>
                        <span v-else> meses</span>
                    </div>
                    <div class="grey--text text--darken-3 mt-1 caption" v-if="permissions.indexOf('view_monetary_data') != -1">
                        Receita gerada até o momento (desde a aquisição do canal): {{formatterMoney.format(info.total_revenue)}}
                    </div>
                </div>
            </v-col>
            <v-col md="2" cols="12" class="d-flex flex-column justify-space-between">
                <div class="elevation-2 pa-4 d-flex align-center justify-center flex-column">
                    <img src="../assets/icons/strikes.svg" alt="">
                    <span class="mt-2 grey--text text--darken-3 body-2">Strikes Recebidos</span>
                    <span class="mt-2 grey--text text--darken-4 body-1 font-weight-bold text-center">{{strikes}}</span>
                </div>
                <div class="elevation-2 pa-4 d-flex align-center justify-center flex-column">
                    <img src="../assets/icons/icon-monetizing.svg" alt="">
                    <span class="mt-2 grey--text text--darken-3 body-2">Monetização:</span>
                    <span class="mt-2 grey--text text--darken-4 body-1 font-weight-bold text-center">{{monetized ? 'Monetizado' : 'Não monetizado'}}</span>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="4" cols="12">
                <div class="elevation-2 pa-4 size-card card-table">
                    <div class="body-1 grey--text text--darken-3">
                        Status da Inscrição
                    </div>
                     <div v-if="chartLoading.subscribers" class="d-flex height-fluid justify-center align-center">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="mt-2 card-percentage"
                            type="PieChart"
                            :data="chartDataItems.subscribers"
                            :options="chartOptionsPie"
                            v-if="chartDataItems.subscribers.length > 2"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col md="4" cols="12">
                <div class="elevation-2 pa-4 size-card card-table">
                    <div class="body-1 grey--text text--darken-3">
                        Gênero
                    </div>
                     <div v-if="chartLoading.gender" class="d-flex height-fluid justify-center align-center">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="mt-2 card-percentage"
                            type="PieChart"
                            :data="chartDataItems.gender"
                            :options="chartOptionsPie"
                            v-if="chartDataItems.gender.length > 2"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col md="4" cols="12">
                <div class="elevation-2 pa-4 size-card">
                    <div class="body-1 grey--text text--darken-3">
                        % Visualizações por país
                    </div>
                    <template>
                        <v-data-table
                            :headers="headers"
                            :items="desserts"
                            hide-default-header
                            hide-default-footer
                            class="mt-4"
                        >
                        <template v-slot:item.country="{ item }">
                            <div class="d-flex align-center">
                                <span>{{item.country}}</span>
                            </div>
                        </template>
                        <template v-slot:item.views_percentage="{ item }">
                            <span>{{item.views_percentage.toFixed(2)}}%</span>
                        </template>
                        </v-data-table>
                    </template>
                </div>
            </v-col>
        </v-row>
                <v-row>
            <v-col md="6" cols="12">
                <div class="elevation-2 pa-4 size-card card-table">
                    % de espectadores por idade e gênero
                     <div v-if="chartLoading.pct_views_gender_age" class="d-flex height-fluid justify-center align-center">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="mt-2 card-percentage"
                            type="BarChart"
                            :data="chartDataItems.pct_views_gender_age"
                            :options="chartOptionsBar"
                            v-if="chartDataItems.pct_views_gender_age.length > 2"
                            />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col md="6" cols="12">
                <div class="elevation-2 pa-4 size-card card-table">
                    Visualizações por dia da semana
                     <div v-if="chartLoading.views_week" class="d-flex height-fluid justify-center align-center">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="mt-2 card-percentage"
                            type="BarChart"
                            :data="chartDataItems.views_week"
                            :options="chartOptionsBar"
                            v-if="chartDataItems.views_week.length > 2"
                            />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="elevation-2 pa-4">
                    <div class="body-1 grey--text text--darken-3 d-flex justify-space-between align-center">
                        <span>Variações</span>
                        <v-col cols="4">
                            <v-select
                                v-model="aggregationSelected"
                                :items="aggregation"
                                item-text="name"
                                item-value="value"
                                label="Periodicidade"
                                @change="getRevenueChange();getMonthViews();"
                            >
                            </v-select>
                        </v-col>
                    </div>
                    <v-row v-if="permissions.indexOf('view_monetary_data') != -1">
                        <v-col cols="12">
                            <div class="elevation-2 pa-4 size-card card-table">
                                Variação de receita
                                 <div v-if="chartLoading.monthly_revenue_change" class="d-flex height-fluid justify-center align-center">
                                    <v-progress-circular
                                    indeterminate
                                    color="primary"
                                    size="72"
                                    ></v-progress-circular>
                                </div>
                                <template v-else>
                                    <GChart
                                        class="mt-2 card-percentage"
                                        type="LineChart"
                                        :data="chartDataItems.monthly_revenue_change"
                                        :options="chartOptionsLine"
                                        v-if="chartDataItems.monthly_revenue_change.length > 2"
                                        />
                                    <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                                        <img src="../assets/empty/empty-cms.svg" alt="">
                                        <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                                        <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                            Não há dados a serem exibidos com este filtro!
                                        </span>
                                    </div>
                                </template>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <div class="elevation-2 pa-4 size-card card-table">
                                Variação de visualizações
                                 <div v-if="chartLoading.monthly_view_variation" class="d-flex height-fluid justify-center align-center">
                                    <v-progress-circular
                                    indeterminate
                                    color="primary"
                                    size="72"
                                    ></v-progress-circular>
                                </div>
                                <template v-else>
                                    <GChart
                                        class="mt-2 card-percentage"
                                        type="LineChart"
                                        :data="chartDataItems.monthly_view_variation"
                                        :options="chartOptionsLine"
                                        v-if="chartDataItems.monthly_view_variation.length > 2"
                                        />
                                    <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                                        <img src="../assets/empty/empty-cms.svg" alt="">
                                        <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                                        <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                            Não há dados a serem exibidos com este filtro!
                                        </span>
                                    </div>
                                </template>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="8">
                <div class="elevation-2 pa-4 body-1 grey--text text--darken-3">
                    Termos de pesquisa
                    <template>
                        <v-data-table
                            :headers="headersSearch"
                            :items="dessertsSearch"
                            class="mt-4"
                        >
                            <template v-slot:item.views="{ item }">
                                <span>{{formatterDecimal.format(item.views)}}</span>
                            </template>
                            <template v-slot:item.minutes_watched="{ item }">
                                <span>{{formatterDecimal.format(item.minutes_watched)}}</span>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </v-col>
            <v-col cols="12" md="4">
                <div class="elevation-2 pa-4 size-card">
                    Origens do Tráfego (% de visualizações)
                    <div v-if="trafficSource.length > 0">
                        <div class="mt-2 elevation-3 pa-2 mt-4 d-flex align-center wrap" v-for="(item, index) in trafficSource" :key="item.traffic_source">
                            <img :src="getIcon(index)" alt="" class="mr-4">
                            <span class="grey--text text--darken-3 body-2">{{item.traffic_source}}: {{item.views_percentage.toFixed(2)}}%</span>
                        </div>
                    </div>
                    <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                        <img src="../assets/empty/empty-cms.svg" alt="">
                        <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                        <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                            Não há dados a serem exibidos com este filtro!
                        </span>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { GChart } from 'vue-google-charts'
import moment from 'moment'
export default {
    components: {
        GChart
    },
    created() {
        const token = this.$jwt.decode();
        if ( token ) {
            this.permissions = token.data.permissions;
        }
        this.getChannelAssets();
        this.getSummary();
        this.getChanelInfo();
        this.getChannelMonetization();
        this.getViewsCountry();
        this.getStrike();
        this.getSubscribers();
        this.getRevenueChange();
        this.getMonthViews();
        this.getGender();
        this.getPctAgeGender();
        this.getWeekDays();
        this.getSearchTerms();
        this.getTraffic();
    },
    props: {
        channel: {
            type: Number,
            required: true,
            default: null
        },
        dateIni: {
            type: String,
            required: true,
            default: null
        },
        dateEnd: {
            type: String,
            required: true,
            default: null
        }
    },
    data: () => ({
        moment: moment,
        permissions: '',
        monetized: '',
        formatterMoney: new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}),
        formatterDecimal: new Intl.NumberFormat('pt-BR', {currency: 'BRL'}),
        aggregationSelected: 'day',
        aggregation: [
            {
                'name': 'Diário',
                'value': 'day'
            },
            {
                'name': 'Semanal',
                'value': 'week'
            },
            {
                'name': 'Mensal',
                'value': 'month'
            }
        ],
        chartDataItems: {
            subscribers: [],
            gender: [],
            pct_views_gender_age: [],
            views_week: [],
            monthly_revenue_change: [],
            monthly_view_variation: [],
        },
        chartLoading: {
            subscribers: true,
            gender: true,
            pct_views_gender_age: true,
            views_week: true,
            monthly_revenue_change: true,
            monthly_view_variation: true
        },
         chartOptionsLine: {
            chartArea: {width:'90%'},
            legend: {position: 'bottom'},
        },
        chartOptionsPie: {
            pieHole: 0.5,
            chartArea: {width:'90%',height:'200'},
            legend: {position: 'bottom'},
        },
        chartOptionsBar: {
            chartArea: {width:'80%',height:'200'},
            legend: {position: 'bottom'},
        },
        headers: [
          { value: 'country', align: 'center', sortable: false },
          { value: 'views_percentage', align: 'end', sortable: false }
        ],
        desserts: [],
        headersSearch: [
          { text: 'Termo de pesquisa', value: 'search_term', align: 'start', sortable: false },
          { text: 'Visualizações', value: 'views', align: 'center', sortable: false },
          { text: 'Exibição (Min.)', value: 'minutes_watched', align: 'center', sortable: false }
        ],
        dessertsSearch: [],
        summary: '',
        info: '',
        strikes: '',
        channelAssets: '',
        assetsSource: [
            'icon-48-link.svg',
            'icon-48-bookmark.svg',
            'icon-48-notification.svg',
            'icon-48-web.svg',
            'icon-48-youtube.svg',
        ],
        trafficSource: []
    }),
    methods: {
        getIcon(index) {
            return require('../assets/icons/' + this.assetsSource[index])
        },
        getChannelAssets() {
            this.$http.get( '/channel/allowed/'+ this.channel)
            .then( ( res ) => {
                this.channelAssets = res.data;
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            });
        },
        getChannelMonetization() {
            this.$http.get( '/analytics/channel/'+this.channel+'/monetization')
            .then( ( res ) => {
                this.monetized = res.data.is_monetizing
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            });
        },
        getSummary() {
            this.$http.get( '/analytics/channel/'+ this.channel +'/summary?start_date='+this.dateIni+'&end_date='+this.dateEnd)
            .then( ( res ) => {
                this.summary = res.data.summary
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            });
        },
        getChanelInfo() {
            this.$http.get( '/analytics/channel/'+ this.channel +'/info?start_date='+this.dateIni+'&end_date='+this.dateEnd)
            .then( ( res ) => {
                this.info = res.data
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            });
        },
        getStrike() {
            this.$http.get( '/analytics/channel/'+ this.channel +'/strikes?start_date='+this.dateIni+'&end_date='+this.dateEnd)
            .then( ( res ) => {
                this.strikes = res.data.strikes
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            });
        },
        getSubscribers() {
            this.$http.get( '/analytics/channel/'+ this.channel +'/subscribed-status?start_date='+this.dateIni+'&end_date='+this.dateEnd)
            .then( ( res ) => {
                const helper = [res.data.columns];
                this.chartDataItems.subscribers = helper.concat(res.data.rows);
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            }) .finally( () => {
                this.chartLoading.subscribers = false;
            } );
        },
        getRevenueChange() {
            if (this.permissions.indexOf('view_monetary_data') != -1) {
                this.$http.get( '/analytics/channel/'+ this.channel +'/revenue?aggregation='+this.aggregationSelected+'&start_date='+this.dateIni+'&end_date='+this.dateEnd)
                .then( ( res ) => {
                    const helper = [res.data.columns];
                    this.chartDataItems.monthly_revenue_change = helper.concat(res.data.rows);
                } ).catch( () => {
                    this.notification = {
                        active: true,
                        description: 'Houve um erro na solicitação.',
                        type: 'error',
                        closeText: 'Fechar'
                    },
                    this.$emit( 'notification', this.notification );
                }) .finally( () => {
                    this.chartLoading.monthly_revenue_change = false;
                } );
                }
        },
        getMonthViews() {
            this.$http.get( '/analytics/channel/'+ this.channel +'/views?aggregation='+this.aggregationSelected+'&start_date='+this.dateIni+'&end_date='+this.dateEnd)
            .then( ( res ) => {
                const helper = [res.data.columns];
                this.chartDataItems.monthly_view_variation = helper.concat(res.data.rows);
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            }) .finally( () => {
                this.chartLoading.monthly_view_variation = false;
            } );
        },
        getGender() {
            this.$http.get( '/analytics/channel/'+ this.channel +'/gender?start_date='+this.dateIni+'&end_date='+this.dateEnd)
            .then( ( res ) => {
                const helper = [res.data.columns];
                this.chartDataItems.gender = helper.concat(res.data.rows);
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            }) .finally( () => {
                this.chartLoading.gender = false;
            } );
        },
        getViewsCountry() {
            this.$http.get( '/analytics/channel/'+ this.channel +'/geographics?start_date='+this.dateIni+'&end_date='+this.dateEnd)
            .then( ( res ) => {
                this.desserts = res.data
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            });
        },
        getPctAgeGender() {
            this.$http.get( '/analytics/channel/'+ this.channel +'/gender-age?start_date='+this.dateIni+'&end_date='+this.dateEnd)
            .then( ( res ) => {
                const helper = [res.data.columns];
                this.chartDataItems.pct_views_gender_age = helper.concat(res.data.rows);
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            }) .finally( () => {
                this.chartLoading.pct_views_gender_age = false;
            } );
        },
        getWeekDays() {
            this.$http.get( '/analytics/channel/'+ this.channel +'/weekdays?start_date='+this.dateIni+'&end_date='+this.dateEnd)
            .then( ( res ) => {
                const helper = [res.data.columns];
                this.chartDataItems.views_week = helper.concat(res.data.rows);
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            }) .finally( () => {
                this.chartLoading.views_week = false;
            } );
        },
        getSearchTerms() {
            this.$http.get( '/analytics/channel/'+ this.channel +'/search-terms?start_date='+this.dateIni+'&end_date='+this.dateEnd)
            .then( ( res ) => {
                this.dessertsSearch = res.data
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            });
        },
        getTraffic() {
            this.$http.get( '/analytics/channel/'+ this.channel +'/traffic-sources?start_date='+this.dateIni+'&end_date='+this.dateEnd)
            .then( ( res ) => {
                this.trafficSource = res.data;
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            });
        }
    }
}
</script>

<style>
    .card-table {
        min-height: 400px;
    }
    .card-percentage {
        height: 400px;
    }
    .size-card {
        height: 100%;
    }
</style>